import { Col, Row } from 'antd';
import styles from './index.module.sass';
import { InputWithSign } from '@/modules/common/components/input-with-sign';
import { useStore } from 'effector-react';
import { $buyerData, fetchBuyerDataFx, setBuyerData } from '../../store/buyer.store';
import { ButtonMain } from '@/modules/common/components/button';
import { $userData } from '@/modules/auth/store/auth.store';
import { updateBuyerData } from '../../functions/update-buyer-data.function';
import { useEffect } from 'react';

export const BuyerRequisites = () => {
  const newBuyer = useStore($buyerData);
  useEffect(() => {
    fetchBuyerDataFx();
    return () => {
      fetchBuyerDataFx();
    }
  }, []);
  return (
    <div className={styles.root}>
      <span className={styles.heading}>информация о компании</span>
      <Row gutter={16}>
        <Col span={12}>
          <InputWithSign
            label="название компании*"
            postfix=""
            value={newBuyer.companyName}
            onChange={(e) => setBuyerData({ ...newBuyer, companyName: e.target.value })}
            placeholder='ООО "Ваша Компания"'
          />
        </Col>
        <Col span={12}>
          <InputWithSign
            label="адрес компании*"
            placeholder="Регион, населенный пункт, улица/массив, дом"
            postfix=""
            value={newBuyer.address}
            onChange={(e) => setBuyerData({ ...newBuyer, address: e.target.value })}
          />
        </Col>
        {/* <Col span={12}>
          <InputWithSign
            label="телефон*"
            placeholder="+7 ("
            onChange={(e) => setBuyerData({ ...newBuyer, phone: e.target.value })}
            postfix=""
            value={newBuyer.phone}
            autoComplete="off"
            mask={[
              '+',
              '7',
              ' ',
              '(',
              /[1-9]/,
              /\d/,
              /\d/,
              ')',
              ' ',
              /\d/,
              /\d/,
              /\d/,
              '-',
              /\d/,
              /\d/,
              '-',
              /\d/,
              /\d/,
            ]}
            blocker={false}
          />
        </Col> */}
        {/* <Col span={12}>
          <InputWithSign
            label="e-mail*"
            placeholder="mail@company.com"
            postfix=""
            value={newBuyer.email}
            onChange={(e) => setBuyerData({ ...newBuyer, email: e.target.value })}
          />
        </Col> */}
        <Col span={12}>
          <InputWithSign
            label="ИНН"
            postfix=""
            placeholder=""
            value={newBuyer.inn}
            onChange={(e) =>
              setBuyerData({
                ...newBuyer,
                inn: e.target.value.replace(/\D/g, ''),
              })
            }
          />
        </Col>
        <Col span={12}>
          <InputWithSign
            label="ОГРН"
            placeholder=""
            postfix=""
            value={newBuyer.ogrn}
            onChange={(e) =>
              setBuyerData({
                ...newBuyer,
                ogrn: e.target.value.replace(/\D/g, ''),
              })
            }
          />
        </Col>
      </Row>
      <ButtonMain label='сохранить изменения' onClick={async () => updateBuyerData(newBuyer)} className={styles.saveButton}/>
    </div>
  );
};
